var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ellipsis-text ellipsis-3",
      style: {
        lineHeight: _vm.lineHeight + "px",
        "-webkit-line-clamp": _vm.lineClamp,
      },
    },
    [
      _vm.isSHowExpand
        ? _c("div", {
            staticClass: "space",
            style: {
              height: _vm.spaceHeight + "px",
            },
          })
        : _vm._e(),
      _vm.isSHowExpand
        ? _c(
            "div",
            { staticClass: "expand-btn", on: { click: _vm.handleExpand } },
            [
              _vm._v(
                _vm._s(
                  _vm.expand
                    ? _vm.$t("pc_biz_ai_retract").d("收起")
                    : _vm.$t("pc_kng_common_btn_pack_open").d("展开")
                )
              ),
            ]
          )
        : _vm._e(),
      _c("span", { ref: "textRef" }, [_vm._v(_vm._s(_vm.text))]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }